<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>csv入出力履歴</h5>
      </div>
    </div>

    <div id="main" class="row">
      <div class="col-1">
      </div>
      <div class="col-10">
        <table class="table table-dark table-sm table-hover">
          <thead>
            <tr>
              <th scope="col" style="width:20px">#</th>
              <th scope="col" style="width:90px">種別</th>
              <th scope="col" style="width:80px">内容</th>
              <th scope="col" style="width:80px">処理件数</th>
              <th scope="col" style="width:90px">ステータス</th>
              <th scope="col">メッセージ</th>
              <th scope="col" style="width:100px">処理日時</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(log, index) in logs" v-bind:key="log.id">
              <th scope="row">{{ currentIndex * limit + index + 1 }}</th>
              <td>{{ log.kind }}</td>
              <td>{{ log.name }}</td>
              <td>{{ log.details }}</td>
              <td>{{ log.status }}</td>
              <td v-html="log.message"></td>
              <td>{{ log.processedAt }}</td>              
            </tr>
          </tbody>
        </table>
        <nav aria-label="pager">
          <ul class="pagination justify-content-center">
            <li v-if="isPrev" v-on:click="goPrev">
              <a class="btn page-link rounded-pill">&larr; 前</a>
            </li>
            <li v-if="isPrev||isNext" class="mx-2">
              <a class="btn page-link rounded-pill">現在</a>
            </li>
            <li v-if="isNext" v-on:click="goNext">
              <a class="btn page-link rounded-pill">次 &rarr;</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-3">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Index',
  mixins: [sessions,path,headers],
  props: ['realms'],
  data: function(){
    return {
      message: '',
      logs: [],
      gridCount: 0,
      currentIndex: 0,
      limit: 20
    }
  },
  mounted() {
    if(this.$store.getters.hospital.id !== 0){
      this.search(true)
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.search(true)
        }
      }
    )
  },
  computed: {
    isNext: function () {
      return this.gridCount === this.limit
    },
    isPrev: function () {
      return this.currentIndex !== 0
    },
    isMessage: function () {
      return this.message.length > 0
    }
  },
  methods: {
    search(isInit) {
      this.$cognito.isAuthenticated().then((session) => {
      if(session){
        if(isInit){
          this.currentIndex = 0
        }
        var offset = this.currentIndex * this.limit
        var accessToken = this.getAccessToken(this.$cognito,session)
        var hospitalId = this.$store.getters.hospital.id
        
        axios.post("/api/log/list/"+offset,{
          hospitalId: hospitalId
        },{
          headers: this.headers(accessToken)
        }).then(response => {
          this.logs = response.data.data.logs
          this.gridCount = this.logs.length
        }).catch(err => {
          this.message = err.message
        })
      } else {
       this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
      }}).catch((err) => {
        this.message = err.message
      })
    },
    goNext(){
      this.currentIndex++
      this.search(false)
    },
    goPrev(){
      this.currentIndex--
      this.search(false)
    },
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#main {
  height: 100%;
}
.btn-sm{
  margin-left: 5px;
}
.search-solid{
  cursor: pointer;
  height: 18px;
  width: 18px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>